import crm from './crm';

const RenegociacaoService = {
  buscarParametrosSimuladorRenegociacao: (idProcesso) => {
    return crm.get(`simulador-renegociacao/processo/${idProcesso}`);
  },
  buscarParcelas: (idProcesso, dataCorte) => {
    return crm.get(`simulador-renegociacao/processo/${idProcesso}/parcelas`, { params: {dataCorte} });
  },
  buscarPermissaoDataCorte: (idProcesso) => {
    return crm.get(`simulador-renegociacao/buscarPermissaoDataCorte`, {params: {idProcesso}});
  },
  buscarRenegociacao: (idProcesso) => {
    return crm.get(`renegociacao/processo/${idProcesso}`);
  },
  buscarMotivoAditivo: (idMotivo) => {
    return crm.get(`motivo-aditivo/${idMotivo}`);
  },
  criarRenegociacao: (dadosRenegociacao) => {
    return crm.post(`renegociacao`, {dadosRenegociacao});
  }
};

export default RenegociacaoService;
